<template>
  <div>
    <div v-b-modal="code">
      <b-form-group
        label-for="DIRECCION"
        :label="label"
        :state="state"
        :invalid-feedback="invalidFeedback"
      >
        <b-form-input
          v-model="localValue"
          disabled
          placeholder="Clic para escribir dirección"
          :state="state"
        ></b-form-input>
      </b-form-group>
    </div>
    <b-modal size="xl" :ref="code" :id="code" title="Ingrese la dirección">
      <b-row>
        <b-col cols="6" lg="3">
          <b-form-group
            class="required"
            :state="vTipoViaPal()"
            label-for="VIA_PRINCIPAL"
            label="Tipo de vía"
          >
            <b-form-select
              :options="viasList"
              v-model="direccion.tipoViaPal"
              :state="vTipoViaPal()"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6" lg="3">
          <b-form-group
            class="required"
            :state="vNumeroPal()"
            label-for="VIA_PRINCIPAL"
            label="Número"
          >
            <b-form-input :state="vNumeroPal()" v-model="direccion.numeroPal"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="6" lg="3">
          <b-form-group label-for="VIA_PRINCIPAL" label="Letra">
            <b-form-select :options="letraList" v-model="direccion.letraPal"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6" lg="3">
          <b-form-group label-for="VIA_PRINCIPAL" label="Zona">
            <b-form-select
              :options="cuadranteList"
              v-model="direccion.cuadrantePal"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6" lg="3">
          <b-form-group
            class="required"
            :state="vViaGen()"
            label-for="VIA_PRINCIPAL"
            label="Número"
          >
            <b-form-input v-model="direccion.viaGen"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="6" lg="3">
          <b-form-group label-for="VIA_PRINCIPAL" label="Letra">
            <b-form-select :options="letraList" v-model="direccion.letraGen"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6" lg="3">
          <b-form-group
            class="required"
            :state="vPlacaGen()"
            label-for="VIA_PRINCIPAL"
            label="Número"
          >
            <b-form-input v-model="direccion.placaGen"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="6" lg="3">
          <b-form-group label-for="VIA_PRINCIPAL" label="Zona">
            <b-form-select
              :options="cuadranteList"
              v-model="direccion.cuadranteGen"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-form @submit.prevent="addComplemento">
            <b-row align-v="end">
              <b-col cols="12" lg="5">
                <b-form-group label-for="VIA_PRINCIPAL" label="Complemento">
                  <b-form-select
                    :options="complementoList"
                    v-model="complemento.tipo"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="5">
                <b-form-group label-for="VIA_PRINCIPAL" label="Texto complemento">
                  <b-form-input v-model="complemento.texto"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="pb-2" cols="12" lg="2">
                <b-form-group>
                  <b-button pill block class="satmed-btn-primary" @click="addComplemento">
                    Agregar
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
      <b-row v-if="direccion.complemento.length">
        <b-col>
          <b-card>
            <div class="d-inline-block" style="font-size: 1.5rem">
              <b-form-tag
                v-for="(complemento, index) in direccion.complemento"
                :key="index"
                @remove="removeCompemento(index)"
                :title="complemento.tipo + ' - ' + complemento.texto"
                class="mr-1 satmed-btn-primary"
              >
                {{ complemento.tipo + ' - ' + complemento.texto }}
              </b-form-tag>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-4" align-v="center">
        <b-col>
          <b-form-group class="flex-fill" label="Dirección ingresada">
            <b-input disabled v-model="localValue"></b-input>
          </b-form-group>
        </b-col>
      </b-row>
      <template slot="modal-footer">
        <b-row class="w-100 mt-3">
          <div class="d-none d-lg-flex align-items-center justify-content-end w-100">
            <div @click="reset" class="mr-3" style="cursor: pointer">
              <b>Cancelar</b>
            </div>
            <b-button
              pill
              size="lg"
              class="satmed-btn-primary"
              @click="hideModal"
              :disabled="formIsInvalid()"
            >
              Aceptar
            </b-button>
          </div>
          <div class="d-block d-lg-none align-items-center justify-content-start w-100">
            <b-button variant="default" @click="reset" class="float-left" style="cursor: pointer">
              <b>Cancelar</b>
            </b-button>
            <b-button
              pill
              size="lg"
              class="satmed-btn-primary float-right"
              @click="hideModal"
              :disabled="formIsInvalid()"
            >
              Aceptar
            </b-button>
          </div>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
<script>
// EJEMPLO: https://geoportal.dane.gov.co/geovisores/territorio/georreferenciador-de-direcciones/
const viasList = [
  { value: null, text: 'Tipo vía', disabled: true },
  { value: 'CL', text: 'Calle' },
  { value: 'KR', text: 'Carrera' },
  { value: 'DG', text: 'Diagonal' },
  { value: 'AU', text: 'Autopista' },
  { value: 'AV', text: 'Avenida' },
  { value: 'AC', text: 'Av. Calle' },
  { value: 'AK', text: 'Av. Carrera' },
  { value: 'CM', text: 'Camino' },
  { value: 'CT', text: 'Carretera' },
  { value: 'CI', text: 'Circular' },
  { value: 'CV', text: 'Circunvalar' },
  { value: 'PRJ', text: 'Paraje' },
  { value: 'PAS', text: 'Paseo' },
  { value: 'TV', text: 'Transversal' },
  { value: 'TC', text: 'Troncal' },
  { value: 'VT', text: 'Variante' },
];
const cuadranteList = [
  { value: '', text: 'Ninguno' },
  { value: 'E', text: 'ESTE' },
  { value: 'S', text: 'SUR' },
  { value: 'N', text: 'NORTE' },
  { value: 'O', text: 'OESTE' },
];
const letraList = [
  { text: 'Sin letra', value: null },
  { text: 'A', value: 'A' },
  { text: 'B', value: 'B' },
  { text: 'C', value: 'C' },
  { text: 'D', value: 'D' },
  { text: 'E', value: 'E' },
  { text: 'F', value: 'F' },
  { text: 'G', value: 'G' },
  { text: 'H', value: 'H' },
  { text: 'I', value: 'I' },
  { text: 'J', value: 'J' },
  { text: 'K', value: 'K' },
  { text: 'L', value: 'L' },
  { text: 'M', value: 'M' },
  { text: 'N', value: 'N' },
  { text: 'Ñ', value: 'Ñ' },
  { text: 'O', value: 'O' },
  { text: 'P', value: 'P' },
  { text: 'Q', value: 'Q' },
  { text: 'R', value: 'R' },
  { text: 'S', value: 'S' },
  { text: 'T', value: 'T' },
  { text: 'U', value: 'U' },
  { text: 'V', value: 'V' },
  { text: 'W', value: 'W' },
  { text: 'X', value: 'X' },
  { text: 'Y', value: 'Y' },
  { text: 'Z', value: 'Z' },
];
const complementoList = [
  { value: null, text: 'Seleccionar...' },
  { value: 'AD', text: 'Administración' },
  { value: 'AGN', text: 'Agencia' },
  { value: 'AG', text: 'Agrupación' },
  { value: 'ALM', text: 'Almacén' },
  { value: 'AL', text: 'Altillo' },
  { value: 'APD', text: 'Apartado' },
  { value: 'AP', text: 'Apartamento' },
  { value: 'AST', text: 'Asentamiento' },
  { value: 'BRR', text: 'Barrio' },
  { value: 'BL', text: 'Bloque' },
  { value: 'BD', text: 'Bodega' },
  { value: 'CS', text: 'Casa' },
  { value: 'CAS', text: 'Caserio' },
  { value: 'CE', text: 'Célula' },
  { value: 'CC', text: 'Centro Comercial' },
  { value: 'CD', text: 'Ciudadela' },
  { value: 'CDM', text: 'Condominio' },
  { value: 'CJ', text: 'Conjunto' },
  { value: 'CJR', text: 'Conjunto Residencial' },
  { value: 'CN', text: 'Consultorio' },
  { value: 'CRG', text: 'Corregimiento' },
  { value: 'CTO', text: 'Cuarto' },
  { value: 'DPTO', text: 'Departamento' },
  { value: 'DP', text: 'Deposito' },
  { value: 'DS', text: 'Deposito Sótano' },
  { value: 'ED', text: 'Edificio ' },
  { value: 'EN', text: 'Entrada' },
  { value: 'ESQ', text: 'Esquina' },
  { value: 'ES', text: 'Estación' },
  { value: 'ET', text: 'Etapa' },
  { value: 'EX', text: 'Exterior' },
  { value: 'FRR', text: 'Ferrocarril' },
  { value: 'FI', text: 'Finca' },
  { value: 'GJ', text: 'Garaje' },
  { value: 'GS', text: 'Garaje Sótano' },
  { value: 'HB', text: 'Habitación' },
  { value: 'HC', text: 'Hacienda' },
  { value: 'IN', text: 'Interior' },
  { value: 'KM', text: 'Kilómetro' },
  { value: 'LC', text: 'Local' },
  { value: 'LM', text: 'Local Mezzanine' },
  { value: 'LT', text: 'Lote' },
  { value: 'MZ', text: 'Manzana' },
  { value: 'MN', text: 'Mezzanine' },
  { value: 'MD', text: 'Módulo' },
  { value: 'MPIO', text: 'Municipio' },
  { value: 'NV', text: 'Nivel' },
  { value: 'OF', text: 'Oficina' },
  { value: 'PA', text: 'Parcela' },
  { value: 'PAR', text: 'Parque' },
  { value: 'PQ', text: 'Parqueadero' },
  { value: 'PTN', text: 'Peatonal' },
  { value: 'PH', text: 'Penthouse' },
  { value: 'PS', text: 'Piso' },
  { value: 'PN', text: 'Plan' },
  { value: 'PL', text: 'Planta' },
  { value: 'PZ', text: 'Plaza' },
  { value: 'PO', text: 'Portería' },
  { value: 'PD', text: 'Predio' },
  { value: 'PT', text: 'Puente' },
  { value: 'PU', text: 'Puesto' },
  { value: 'QT', text: 'Quinta' },
  { value: 'RS', text: 'Residencia' },
  { value: 'RP', text: 'Round Point' },
  { value: 'SA', text: 'Salón' },
  { value: 'SC', text: 'Salón Comunal' },
  { value: 'SCT', text: 'Sector' },
  { value: 'SS', text: 'Semisótano' },
  { value: 'SL', text: 'Solar' },
  { value: 'SO', text: 'Sótano' },
  { value: 'SU', text: 'Suite' },
  { value: 'SM', text: 'Supermanzana' },
  { value: 'TM', text: 'Terminal' },
  { value: 'TZ', text: 'Terraza' },
  { value: 'TO', text: 'Torre' },
  { value: 'UN', text: 'Unidad' },
  { value: 'UR', text: 'Unidad Residencial' },
  { value: 'UB', text: 'Urbanización' },
  { value: 'VD', text: 'Vereda' },
  { value: 'VIA', text: 'Vía' },
  { value: 'VDU', text: 'Víaducto' },
  { value: 'ZN', text: 'Zona' },
  { value: 'ZF', text: 'Zona Franca' },
];

const complementoDefault = {
  texto: null,
  tipo: null,
};

const direccionDefault = {
  tipoViaPal: null,
  numeroPal: null,
  letraPal: null,
  cuadrantePal: null,
  viaGen: null,
  letraGen: null,
  placaGen: null,
  cuadranteGen: null,
  complemento: [],
};

export default {
  name: 'InputDireccion',
  props: {
    value: {
      required: true,
    },
    label: String,
    invalidFeedback: {
      type: String,
      default: '',
    },
    state: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localValue: this.value,
      viasList,
      letraList,
      cuadranteList,
      complementoList,
      /** @type {{complemento: {tipo: string, texto: string}[]} & {[key:string]: string}} */
      direccion: JSON.parse(JSON.stringify(direccionDefault)),
      complemento: JSON.parse(JSON.stringify(complementoDefault)),
      code: `modal-${Math.round(Math.random() * 1000000000)}`,
    };
  },
  methods: {
    addComplemento() {
      this.direccion.complemento.push(this.complemento);
      this.complemento = JSON.parse(JSON.stringify(complementoDefault));
    },
    removeCompemento(index) {
      this.direccion.complemento = this.direccion.complemento.filter((e, id) => id !== index);
    },
    formIsInvalid() {
      return !this.vTipoViaPal() || !this.vNumeroPal() || !this.vViaGen() || !this.vPlacaGen();
    },
    vTipoViaPal() {
      if (this.direccion.tipoViaPal === null) {
        return null;
      }
      if (this.direccion.tipoViaPal) {
        return true;
      }
      return false;
    },
    vNumeroPal() {
      if (this.direccion.numeroPal === null) {
        return null;
      }
      if (this.direccion.numeroPal) {
        return true;
      }
      return false;
    },
    vViaGen() {
      if (this.direccion.viaGen === null) {
        return null;
      }
      if (this.direccion.viaGen) {
        return true;
      }
      return false;
    },
    vPlacaGen() {
      if (this.direccion.placaGen === null) {
        return null;
      }
      if (this.direccion.placaGen) {
        return true;
      }
      return false;
    },
    reset() {
      this.direccion = JSON.parse(JSON.stringify(direccionDefault));
      this.localValue = '';
      this.hideModal();
    },
    hideModal() {
      this.$refs[this.code].hide();
    },
  },
  watch: {
    localValue(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.localValue = value;
    },
    direccion: {
      handler(v) {
        this.localValue = v.tipoViaPal ? v.tipoViaPal : '';
        this.localValue += v.numeroPal ? ` ${v.numeroPal}` : '';
        this.localValue += v.letraPal ? `${v.letraPal}` : '';
        this.localValue += v.cuadrantePal ? ` ${v.cuadrantePal}` : '';
        this.localValue += v.viaGen ? ` # ${v.viaGen}` : '';
        this.localValue += v.letraGen ? `${v.letraGen}` : '';
        this.localValue += v.placaGen ? ` - ${v.placaGen}` : '';
        this.localValue += v.cuadranteGen ? ` ${v.cuadranteGen}` : '';

        for (let i = 0; i < v.complemento.length; i += 1) {
          this.localValue += ` ${v.complemento[i].tipo}`;
          this.localValue += ` ${v.complemento[i].texto}`;
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped></style>
